import { create } from 'zustand';

const useEventsStore = create((set) => ({
  events: [],
  filters: { sport: null, status: 'upcoming', search: '' },
  setEvents: (events) => set({ events }),
  updateOdds: (market_id, odds) => set((state) => ({
    events: state.events.map((e) => ({
      ...e,
      markets: e.markets.map((m) => (m.id === market_id ? { ...m, ...odds } : m))
    }))
  })),
  setFilters: (filters) => set({ filters }),
}));

export default useEventsStore;
